module.exports = __webpack_public_path__ + "static/media/moot5b.7c3eec62.JPG";